import { defineComponent as _defineComponent } from 'vue'
import { Leads, CONSTANTS } from "@busy-human/k9-library";
import { computed } from "vue";

type Lead = Leads.Model
type Props = {
	leadItem : Lead,
	loading  : boolean,
	checkStatus : boolean,
	email: string,
	interest: string,
	errorMessages: {
		[key: string]: string,
	}
}

type Emits = {
	(e: "createCustAcct", leadId: string):void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'leads-details',
  props: {
    leadItem: {},
    loading: { type: Boolean },
    checkStatus: { type: Boolean },
    email: {},
    interest: {},
    errorMessages: {}
  },
  emits: ["createCustAcct"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();


/**
 * TODO:
 * - Need to make props non-mutable
 * - POSTAL CODE: Add postal code to user model, and display it here. Should also be editable
 */

const props = __props;

const selectedItem = computed(()=>props.leadItem);

/** Emit: Create Customer Account */
const emit = __emit;

const interestOptions       = CONSTANTS.PRODUCT_INTEREST;
const originOptions         = CONSTANTS.LEAD_ORIGIN;
const activityStatusOptions = CONSTANTS.STATUS;

const createCustAccount = () => {
	try {
		const leadId = props.leadItem._id;
		emit("createCustAcct", leadId);

	} catch (err) {
		console.log("The error was:", err);
	}
};

const checkDate = () => {
	const [currentDay] = new Date().toISOString().split('T');
	document.getElementById("datepicker")?.setAttribute("max", currentDay);
};

const generateEmail = (email: string, interest: string) => {
	try {
		window.open(`mailto:${  email  }?subject=Hello from Canine Revolution&body=Thank you for your interest in Canine Revolution Dog Training. Are there any questions we can answer about your interest in ${  interest  }? ` + `We are happy to help in any way we can, and hope to hear from you soon.`);
	} catch (err) {
		console.log("The error was:", err);
	}
};


const __returned__ = { props, selectedItem, emit, interestOptions, originOptions, activityStatusOptions, createCustAccount, checkDate, generateEmail, get Leads() { return Leads }, get CONSTANTS() { return CONSTANTS }, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})